import { AppConsts } from '../enums/AppConsts';

export const getToken = () => localStorage.getItem(AppConsts.AccessToken);

export const getHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });
